module.exports = __webpack_public_path__ + "img/prerogative_5@2x.4af9495d.png";